import { useState, useCallback } from 'react';

interface ApiError {
  message: string;
  details?: string;
  code?: string;
}

interface UseApiErrorReturn {
  error: ApiError | null;
  setError: (error: ApiError | null) => void;
  clearError: () => void;
  handleError: (error: unknown) => void;
}

export const useApiError = (): UseApiErrorReturn => {
  const [error, setError] = useState<ApiError | null>(null);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const handleError = useCallback((error: unknown) => {
    console.error('API Error:', error);
    
    if (error instanceof Error) {
      setError({
        message: error.message,
        details: error.stack,
        code: 'UNKNOWN_ERROR'
      });
    } else if (typeof error === 'string') {
      setError({
        message: error,
        code: 'STRING_ERROR'
      });
    } else if (error && typeof error === 'object' && 'message' in error) {
      setError({
        message: (error as any).message,
        details: (error as any).details || (error as any).stack,
        code: (error as any).code || 'OBJECT_ERROR'
      });
    } else {
      setError({
        message: 'An unknown error occurred',
        code: 'UNKNOWN_ERROR'
      });
    }
  }, []);

  return {
    error,
    setError,
    clearError,
    handleError
  };
};
